/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Iframe from 'DesignSystem/Iframe/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CoreEmbeddableSection/Content"
  
}) {
let coreEmbeddedSectionUrlValueData = fromData.useDataValue({ viewPath,
context: 'core_embedded_section',
path: 'url',
})
  return (<React.Fragment
>
<Iframe
  viewPath={`${viewPath}/Iframe`}
 data="core_embedded_section.url"
 src={coreEmbeddedSectionUrlValueData}
/>
{children}
</React.Fragment>)
}